/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Deals_Marked_LostInputs */

const cs_deals_marked_lost = /** @type {(inputs: Deals_Marked_LostInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Obchod označen jako prohraný`)
};

const en_deals_marked_lost = /** @type {(inputs: Deals_Marked_LostInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deal marked as lost`)
};

/**
* | output |
* | --- |
* | "Deal marked as lost" |
*
* @param {Deals_Marked_LostInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const deals_marked_lost = /** @type {((inputs?: Deals_Marked_LostInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Deals_Marked_LostInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_deals_marked_lost(inputs)
	return cs_deals_marked_lost(inputs)
});